import { readFile } from "node:fs/promises";
import { homedir } from "node:os";
import { join } from "node:path";

import { resolveSkillsRunner } from "./external.js";
import type {
  ExternalInvocation,
  ExternalSetupRunner,
  SetupOptions,
} from "./types.js";

const SKILLS_STATE_DIR = "skills";
const SKILLS_LOCK_FILE = ".skill-lock.json";

type SkillSelectionLock = {
  lastSelectedAgents?: unknown;
};

export function buildSkillsAddInvocation(options: SetupOptions, env: NodeJS.ProcessEnv): ExternalInvocation {
  const command = options.runner === "auto" ? resolveSkillsRunner(env) : options.runner;
  const args = ["skills", "add", options.source, "--skill", options.skill];

  if (options.scope === "global") {
    args.push("-g");
  }
  for (const agent of options.agents ?? []) {
    args.push("-a", agent);
  }
  if (options.copy) {
    args.push("--copy");
  }
  if (options.yes) {
    args.push("-y");
  }

  return { args, command };
}

export function buildSkillsListInvocation(
  runner: ExternalSetupRunner,
  scope: SetupOptions["scope"],
) {
  const args = ["skills", "list", "--json"];
  if (scope === "global") {
    args.push("-g");
  }
  return { args, command: runner };
}

export async function readLastSelectedAgents(env: NodeJS.ProcessEnv) {
  const stateHome = env.XDG_STATE_HOME;
  const lockPath =
    stateHome === undefined
      ? join(homedir(), ".agents", SKILLS_LOCK_FILE)
      : join(stateHome, SKILLS_STATE_DIR, SKILLS_LOCK_FILE);

  try {
    const content = await readFile(lockPath, "utf8");
    const parsed = JSON.parse(content) as SkillSelectionLock;
    if (!Array.isArray(parsed.lastSelectedAgents)) {
      return undefined;
    }
    const agents = parsed.lastSelectedAgents.filter(
      (value): value is string => typeof value === "string" && value.length > 0,
    );
    return agents.length === 0 ? undefined : agents;
  } catch {
    return undefined;
  }
}
